import type { FaireProductEntity } from "../../entity_types/product";

export const p_3yxkxb6f9s: FaireProductEntity = {
  token: "p_3yxkxb6f9s",
  type: "product",
  name: "Thistle Be A Beautiful Day Drying Mat",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/0b97e7149077d8f36494a2ee46d71f08b131cd190102fbc0881a0193cb71eee5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6fcbafa611e436b631d7cc996252087cce8f532570c740176e1efeb62b6e3923.jpeg",
    "https://cdn.faire.com/fastly/596de73ea7ad9f8adbc977c770d0a3394f84e7841f4897256629484b199056e7.jpeg",
    "https://cdn.faire.com/fastly/80587e3e507db4698a787d27ca8737bbd1b5f9d273949caa646b3e2d6d093552.jpeg",
    "https://cdn.faire.com/fastly/3b5a7c48175074af7bdf8164797b5fac8520e01c3acfc76ccf0428a4f6ea1511.jpeg"
  ],
  priceDollars: 5,
  description: "An ultra-absorbent drying mat from our Garden Collection displaying a pattern of vintage thistle art complemented with a flower themed pun that reads \"Thistle Be A Beautiful Day.\" This floral drying mat features a full color design on the 21 inch by 14 inch space to place items for drying with a coordinating purple color on the back and trim. Our Thistle Be A Beautiful Day drying mat includes a hanger at the top to display the design or to air dry when not in use. Kitchen drying mat is conveniently machine-washable for easy cleaning and folds up for easy storage. A fun botanical kitchen accessory perfect for everyday use.",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:07.708Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
